import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      & {\n        height: ", "px;\n        padding: ", ";\n        font-size: ", "rem;\n        font-weight: ", ";\n        i {\n          font-size: ", "rem;\n        }\n        span[data-start] {\n          margin-right: ", "px;\n        }\n        span[data-end] {\n          margin-left: ", "px;\n        }\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        & {\n          height: ", "rem;\n          &:after {\n            height: ", "rem;\n          }\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        & {\n          height: ", "rem;\n          &:after {\n            height: ", "rem;\n          }\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        & {\n          font-family: ", ";\n          font-size: ", "rem;\n          font-weight: ", ";\n          line-height: ", "rem;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from "styled-components";
import { generateMedia } from "styled-media-query";
export var fonts = {
  text: 'Muli, -apple-system, Roboto, "Segoe UI", sans-serif',
  web: 'Raleway, -apple-system, Roboto, "Segoe UI", sans-serif'
};
export var gradients = {
  blue: ["#335978", "#9abcc6"],
  green: ["#69c028", "#22a36e"],
  dark: ["#2a3540", "#52667a"]
};
export var font = function font() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ui";
  return fonts[name];
};
export var text = function text() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "text";
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "m";
  return textsCss[type] && textsCss[type][size];
};
export var button = function button() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "m";
  return buttonsCss[size];
};
export var skeleton = function skeleton() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "text";
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "m";
  return skeletonsCss[type] && skeletonsCss[type][size];
};
export var gradient = function gradient(name, inverted) {
  return gradients[name] && (inverted ? _toConsumableArray(gradients[name]).reverse() : gradients[name]);
};
export var textEllipsis = css(_templateObject());
export var breakpoints = {
  xs: 0,
  sm: 48,
  md: 62,
  lg: 80
};
export var media = generateMedia({
  wide: "".concat(breakpoints.lg, "rem"),
  desktop: "".concat(breakpoints.md, "rem"),
  tablet: "".concat(breakpoints.sm, "rem")
});
var textSizes = {
  text: {
    xs: {
      fontSize: 11,
      lineHeight: 16,
      fontWeight: 400
    },
    s: {
      fontSize: 13,
      lineHeight: 20,
      fontWeight: 400
    },
    m: {
      fontSize: 15,
      lineHeight: 24,
      fontWeight: 400
    },
    l: {
      fontSize: 18,
      lineHeight: 26,
      fontWeight: 400
    },
    xl: {
      fontSize: 20,
      lineHeight: 28,
      fontWeight: 400
    },
    xxl: {
      fontSize: 30,
      lineHeight: 38,
      fontWeight: 400
    }
  },
  title: {
    s: {
      fontSize: 14,
      lineHeight: 20,
      fontWeight: 600
    },
    m: {
      fontSize: 17,
      lineHeight: 24,
      fontWeight: 600
    },
    l: {
      fontSize: 20,
      lineHeight: 28,
      fontWeight: 600
    },
    xl: {
      fontSize: 20,
      lineHeight: 28,
      fontWeight: 600
    },
    xxl: {
      fontSize: 20,
      lineHeight: 28,
      fontWeight: 600
    }
  },
  webtext: {
    xs: {
      fontSize: 12,
      lineHeight: 16,
      fontWeight: 400
    },
    s: {
      fontSize: 14,
      lineHeight: 20,
      fontWeight: 400
    },
    m: {
      fontSize: 16,
      lineHeight: 24,
      fontWeight: 400
    },
    l: {
      fontSize: 18,
      lineHeight: 28,
      fontWeight: 400
    },
    xl: {
      fontSize: 22,
      lineHeight: 32,
      fontWeight: 400
    },
    xxl: {
      fontSize: 32,
      lineHeight: 48,
      fontWeight: 400
    }
  },
  webtitle: {
    s: {
      fontSize: 16,
      lineHeight: 24,
      fontWeight: 700
    },
    m: {
      fontSize: 20,
      lineHeight: 28,
      fontWeight: 700
    },
    l: {
      fontSize: 24,
      lineHeight: 32,
      fontWeight: 700
    },
    xl: {
      fontSize: 32,
      lineHeight: 40,
      fontWeight: 800
    },
    xxl: {
      fontSize: 48,
      lineHeight: 56,
      fontWeight: 800
    }
  }
};
var buttonSizes = {
  xs: {
    height: 24,
    padding: "0px 6px",
    fontSize: 10,
    fontWeight: 600,
    iconSize: 16,
    iconMargin: 2
  },
  s: {
    height: 30,
    padding: "0px 8px",
    fontSize: 12,
    fontWeight: 600,
    iconSize: 20,
    iconMargin: 4
  },
  m: {
    height: 40,
    padding: "0px 12px",
    fontSize: 15,
    fontWeight: 600,
    iconSize: 24,
    iconMargin: 6
  },
  l: {
    height: 50,
    padding: "0px 16px",
    fontSize: 17,
    fontWeight: 600,
    iconSize: 24,
    iconMargin: 8
  },
  xl: {
    height: 60,
    padding: "0px 16px",
    fontSize: 19,
    fontWeight: 600,
    iconSize: 26,
    iconMargin: 8
  }
};

var buildTextCss = function buildTextCss(textConfig, fontName) {
  return Object.entries(textConfig).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        size = _ref2[0],
        properties = _ref2[1];

    return _objectSpread({}, acc, _defineProperty({}, size, css(_templateObject2(), font(fontName), properties.fontSize / 16, properties.fontWeight, properties.lineHeight / 16)));
  }, {});
}; // Build css for texts


export var textsCss = {
  text: buildTextCss(textSizes.text, "text"),
  title: buildTextCss(textSizes.title, "text"),
  webtext: buildTextCss(textSizes.webtext, "text"),
  webtitle: buildTextCss(textSizes.webtitle, "web")
}; // Build css for skeletons

export var skeletonsCss = {
  text: Object.entries(textSizes.text).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        size = _ref4[0],
        properties = _ref4[1];

    return _objectSpread({}, acc, _defineProperty({}, size, css(_templateObject3(), properties.lineHeight / 16, properties.fontSize / 16)));
  }, {}),
  title: Object.entries(textSizes.title).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        size = _ref6[0],
        properties = _ref6[1];

    return _objectSpread({}, acc, _defineProperty({}, size, css(_templateObject4(), properties.lineHeight / 16, properties.fontSize / 16)));
  }, {})
}; // Build css for button

export var buttonsCss = Object.entries(buttonSizes).reduce(function (acc, _ref7) {
  var _ref8 = _slicedToArray(_ref7, 2),
      size = _ref8[0],
      properties = _ref8[1];

  return _objectSpread({}, acc, _defineProperty({}, size, css(_templateObject5(), properties.height, properties.padding, properties.fontSize / 16, properties.fontWeight, properties.iconSize / 16, properties.iconMargin, properties.iconMargin)));
}, {});